import React from 'react';
import PropTypes from 'prop-types';

export function Title({title, theme}) {
  return title.length > 0 ? (
    <h5 className='gelDragDrop_title'>{title}</h5>
  ) : null;
}

Title.propTypes = {
  /**
   * Title description for GelDragDrop
   */
  title: PropTypes.string,
};
